<template>
  <v-modal
    :backdrop-static="true"
    body-classes="modal-body px-24 px-md-36 px-xl-96"
    header-classes="justify-content-center text-center border-0 pt-32 px-24 px-md-36 px-xl-96"
    @closed="closeModal">
    <template v-slot:modal-header>

      <span v-if="!!trans?.modalForgotHeader"
            class="h6"
      >{{ trans.modalForgotHeader }}</span>
    </template>

    <template v-slot:default>
      <p v-if="!!trans?.modalForgotDescription" class="d-block text-center text-white text-lg">
        {{ trans.modalForgotDescription }}</p>

      <Form ref="form" v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
        <div class="uq-stripe-form-container row text-white">
          <div class="form-group col-12">

            <label v-if="!!trans?.emailLabel"
                   class="form-label"
            >{{ trans.emailLabel ?? 'Email' }} *</label>

            <Field
              id="email"
              v-model="email"
              aria-describedby="email"
              class="form-control mb-16"
              name="email"
              type="email"
              @keyup.enter="handleSubmit($event, sendEmail)"
            />

            <ErrorMessage class="invalid-feedback" name="email"/>
          </div>
        </div>

        <div class="submit-section d-flex flex-column align-items-center mb-16">
          <p v-if="errorMessage?.length > 0" class="invalid-feedback error mb-12 d-block">
            {{ errorMessage }}
          </p>

          <p v-if="successMessage?.length > 0" class="mb-12 d-block text-md">
            {{ successMessage }}
          </p>

          <button
            :disabled="disabled || sendingEmail"
            class="btn btn-primary w-100 mb-8 mt-12"
            type="button"
            @click="handleSubmit($event, sendEmail)">
            <span v-if="!sendingEmail">{{ trans.buttonSend ?? 'Send' }}</span>
            <span v-else>{{ trans.buttonLoadingLabel ?? 'Loading' }}</span>
          </button>

          <button class="btn text-white link"
                  @click="closeModal">
            <span>{{ trans.buttonLogin ?? 'Login' }}</span>
          </button>
        </div>
      </Form>

    </template>
  </v-modal>
</template>

<script>
import VModal from './vendor/modal/VModal';
import { ErrorMessage, Field, Form } from 'vee-validate';
import * as yup from 'yup';
import api from '@assets/js/front/checkout/api';

export default {
  name: 'ForgotPasswordModal',
  components: {
    VModal,
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    trans: {
      required: true,
    },
    locale: {
      required: true,
      type: String,
    },
  },
  emits: ['modal-closed'],
  data() {
    const schema = {};

    return {
      schema,
      email: '',
      sendingEmail: false,
      disabled: false,

      successMessage: '',
      errorMessage: '',
    };
  },
  async mounted() {
    const spanish = {
      mixed: {
        required: 'El campo es obligatorio',
      },
      string: {
        email: 'Introduce un email válido',
      },
    };

    const english = {
      mixed: {
        required: 'The field is required',
      },
      string: {
        email: 'Email must be a valid email',
      },
    };

    yup.setLocale(this.locale === 'es' ? spanish : english);

    this.schema = yup.object().shape({
      email: yup.string().required().email().label('Email'),
    });
  },
  methods: {
    closeModal() {
      this.$emit('modal-closed');
    },

    async sendEmail(formData) {
      this.sendingEmail = true;
      this.successMessage = '';
      this.errorMessage = '';
      this.disabled = true;

      try {
        let data = {
          email: formData.email,
        };

        const response = await api.auth.forgotPassword(data);

        this.successMessage = response.message;
      } catch (e) {
        console.error(e);

        if (!!e.response?.data?.message) {
          this.errorMessage = e.response?.data?.message;
        }

        throw e;
      } finally {
        this.sendingEmail = false;
        this.disabled = false;
      }
    },
  },
};
</script>
